class TokenService {

    checkUserToken(token) {
      return new Promise(async (resolve, reject) => {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/token/${token}/user`, {
          method: 'GET',
          headers: {  
            'token': token
          }
        })
          .then(data => resolve(data.json()))
          .catch(err => reject(err))
      })
    }

    checkStudentToken(token) {
      return new Promise(async (resolve, reject) => {
        await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/token/${token}/student`, {
          method: 'GET',
          headers: {  
            'token': token
          }
        })
          .then(data => resolve(data.json()))
          .catch(err => reject(err))
      })
    }
}

  export default TokenService;